import ProfileRequestService from 'js/services/api/passenger/profile-requests.js'

import template from './index.pug'

const GC_CODE = '120'

export default {
  template: template(),
  data() {
    const vm = this

    return {
      fileValidations: {
        formats: [
          'image/png',
          'image/jpg',
          'image/jpeg',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ],
        maxSize: 2 * 1024 * 1024
      },
      formErrors: {
        other_documents: []
      },
      maxDocuments: 1,
      showModalForm: false,
      profile_id: '',
      valid_from: '',
      valid_until: '',
      account: vm.account,
      media_profiles: [],
      files_needed: {},
      documents_needed: [],
      documents_needed_file: [
        { key: 'other_documents', files: [] }
      ],
      my_profile_requests: [],
      date_needed: false,
      selected_profile: false,
      enableSendButton: true,
      datepickerConfig: {
        allowInput: true,
        formatDate(date) {
          return moment(date).format('DD/MM/YYYY')
        },
        parseDate(date) {
          return moment(date, 'DD/MM/YYYY').toDate()
        },
        disableMobile: true,
        minDate: moment().toDate()
      }
    }
  },

  computed: {
    // Check if other documents need to be viewed or not HU1303
    showOtherDocuments() {
      let newNeededDocuments = this.documents_needed
      if (this.$municipality.code.toString() !== GC_CODE) { return newNeededDocuments }

      if (this.documents_needed.some(doc => doc.key === 'other_documents')) {
        // If some of these documents exist, we do not display 'other_documents' HU1303
        const noNeedOtherDocuments = this.documents_needed.some(
          doc => doc.key === 'retirement_certificate' ||
          doc.key === 'parent_dni' || doc.key === 'familyBook'
        );

        const noOtherDocument = this.documents_needed.filter(doc => doc.key !== 'other_documents')

        newNeededDocuments = noNeedOtherDocuments ? noOtherDocument : this.documents_needed
      }

      return newNeededDocuments
    },

    /**
     * Builds a list of all the available profiles which the user has not applied
     * @todo This logic should be in Vuex
     * @returns {Array} array with the properties required for an ns-dropdown
     */
    profileRequestProfileIdSelectOptions() {
      // Get all of the profiles for the area_administrativa
      const default_media_profile = this.$administrativeArea.config.default_media_profile

      // Get the profiles already requested IGNORE rejected
      const currentActiveRequests = this.my_profile_requests.filter(req => {
        return req.status !== 'rejected'
      })
      const activeRequestCodes = currentActiveRequests.map(i => i.profile_code)

      // Return a map of the available profiles the user can apply for
      // The filter removes the default profile for the area_administrativa
      // AND any profiles the user has already requested
      return this.$administrativeArea.media_profiles
        .filter(media_profile => {
          return media_profile.code !== default_media_profile 
                   && !activeRequestCodes.includes(media_profile.code)
        })
        .map(media_profile => {
          return {label: `${media_profile.name}`, value: media_profile.id}
        })
    },

    /**
     * Logic to decide if the send button should be disabled
     * @returns {Bool}
     */
    sendButtonDisabled() {
      const errors = []
      // Check dates
      if ((this.selected_profile && this.selected_profile.requires_expiration_date) || this.date_needed) {
        const from = moment(this.valid_from)
        const to = moment(this.valid_until)

        if (!this.valid_from) errors.push('valid_from is empty')
        if (!from.isValid()) errors.push('valid_from has invalid date')

        if (!this.valid_until) errors.push('valid until is empty')
        if (!to.isValid()) errors.push('valid_until has invalid date')

        if (from.isAfter(to, 'day')) errors.push('valid_from is later than valid_to')
      }

      // Check files
      /** If any of the required documents doesn't exist button is disabled */
      this.documents_needed.forEach(upload => {
        if (upload.key !== 'other_documents' && (_.isEmpty(upload.files) ||
        !_.isEmpty(this.formErrors[upload.key]))) {
          errors.push(`${upload.key} has no document`)
        }
      })

      return errors.length > 0
    },
    orderedDocumentsNeeded() {
      const getDocs = this.showOtherDocuments
      const docs = [...getDocs]

      return docs.sort((a, b) => {
        if (a.key === 'other_documents') return 1
        if (b.key === 'other_documents') return -1

        return 0
      })
    },
    visibleOtherDocuments() {
      let documents = []
      const destination = this.documents_needed_file.find(
        doc => doc.key === 'other_documents'
      )

      const files = destination?.files || []

      // total number of visible inputs = uploaded files + 1 empty (max. maxDocuments)
      const total = Math.min(files.length + 1, this.maxDocuments)

      // we return a sequentially numbered list
      documents = Array.from({ length: total }, (_, i) => ({
        pos: i, // índice real en el array
        label: i + 1, // número de documento visible
        file: files[i] || null,
        uid: files[i]?.name || `empty-${i}`
      }))

      return documents
    }
  },

  created() {
    this.loadMediaProfiles()
    this.documents_needed = []
  },

  watch: {

    /**
     * Checks for invalid dates and invalidates if necessary
     * @param {*} newVal
     * @return {Void}
     */
    valid_from(newVal) {
      if (typeof (newVal) === 'undefined') {
        this.valid_from = ''
      }
      const today = moment()
      const date = moment(newVal)
      if (!date.isValid() && date.isBefore(today)) {
        this.valid_from = ''
      } else {
        this.valid_from = newVal
      }
    },

    /**
     * Checks for invalid dates and invalidates if necessary
     * @param {*} newVal
     * @return {Void}
     */
    valid_until(newVal) {
      if (typeof (newVal) === 'undefined') {
        this.valid_until = ''
      }
      const today = moment()
      const date = moment(newVal)
      if (!date.isValid() && date.isBefore(today)) {
        this.valid_until = ''
      } else {
        this.valid_until = newVal
      }
    },

    /**
     * This watches the selected profile and builds the fields
     * @param {*} newVal
     */
    profile_id(newVal) {
      let doc_needed = []
      this.documents_needed = []
      this.resetErrors()

      const selected_profile = this.$administrativeArea.media_profiles.find(profile => profile.id === newVal)
      if (!selected_profile) {
        this.selected_profile = false
        this.date_needed = false

        return
      }

      this.selected_profile = selected_profile
      this.date_needed = selected_profile.requires_expiration_date

      for (const [key, val] of Object.entries(selected_profile.documents)) {
        if (val === true) {
          doc_needed.push({key, files: []})
        }
      }

      doc_needed = this.isMinor(doc_needed)
      this.documents_needed_file = doc_needed
      this.documents_needed = doc_needed
      this.maxDocuments = selected_profile.maximum_other_documents
    }
  },
  methods: {
    // set the name of the labels of inputs
    setLabel(document) {
      if (document.key === 'other_documents') {
        const profile = this.$administrativeArea.media_profiles.filter(
          x => x.id === this.profile_id
        )

        const otherLabel = this.$t(`paymentMedias.profileRequests.documentsNeeded.${document.key}`)

        return profile[0].description || otherLabel
      }

      return this.$t(`paymentMedias.profileRequests.documentsNeeded.${document.key}`)
    },

    /** @todo Move to vuex once branches are stable */
    loadMediaProfiles() {
      const vm = this
      const params = {
        administrative_area_id: vm.$currentAccount.administrative_area_id,
        rut: vm.$currentAccount.rut,
        document_type: vm.$currentAccount.document_type || 1
      }
      ProfileRequestService.index(params).then(mp => {
        this.my_profile_requests = mp.data
      })
      
    },

    closeModalForm() {
      this.$router.push({
        ...this.$route,
        query: {
          showModalForm: undefined
        }
      })
    },

    submit() {
      this.resetErrors()
      if (this.valid()) {
        this.createProfileRequest()
      }
    },

    valid() {
      this.resetErrors()
      const errors = []
      if (this.selected_profile) {
        if (this.profile_id === '') {
          this.$set(
            this.formErrors,
            'profile_id',
            this.$t('paymentMedias.profileRequests.formErrors.required')
          )
          errors.push(false)
        }
        if (!this.validateDates()) errors.push(false)
        if (!this.validateFiles()) errors.push(false)
      }

      return !errors.includes(false)
    },

    validateDates() {
      const errors = []

      // Reset date errors
      this.$set(this.formErrors, 'valid_from', '')
      this.$set(this.formErrors, 'valid_until', '')

      if ((this.selected_profile && this.selected_profile.requires_expiration_date) || this.date_needed) {
        if (this.valid_from === '') {
          this.$set(
            this.formErrors,
            'valid_from',
            this.$t('paymentMedias.profileRequests.formErrors.required')
          )
          errors.push(false)
        }

        if (this.valid_until === '') {
          this.$set(
            this.formErrors,
            'valid_until',
            this.$t('paymentMedias.profileRequests.formErrors.required')
          )
          errors.push(false)
        }

        if (this.valid_from && this.valid_until) {
          const valid_from = moment.utc(this.valid_from)
          const valid_until = moment.utc(this.valid_until)

          if (valid_from.isAfter(valid_until, 'day')) {
            this.$set(
              this.formErrors,
              'valid_from',
              this.$t('paymentMedias.profileRequests.formErrors.until_before_to')
            )
            errors.push(false)
          }
        }

        return !errors.includes(false)
      }

      return true
    },

    validateFiles() {
      const errors = []
      if (this.documents_needed) {
        Object.values(this.documents_needed_file).forEach(obj => {
          if (obj.files.length <= 0 && obj.key !== 'other_documents') {
            this.$set(
              this.formErrors,
              obj.key,
              this.$t('paymentMedias.profileRequests.formErrors.required')
            )
            errors.push(false)
          }
        })
      }

      return !errors.includes(false)
    },

    resetErrors() {
      this.formErrors = {}
      this.acceptConditionsError = ''
    },

    /**
     * Validates an individual file.
     * Errors are added to the formErrors object
     * @param {Object} document
     * @returns {Void}
     */
    onFileChange(event, document, index = null) {
      const uploadedFile = event.target.files[0]
      const errorMessages = []
      const destination = this.documents_needed_file.find(doc => doc.key === document.key)

      if (document.key === 'other_documents') {
        if (!Array.isArray(destination.files)) {
          Vue.set(destination, 'files', [])
        }
        if (!Array.isArray(this.formErrors.other_documents)) {
          Vue.set(this.formErrors, 'other_documents', [])
        }

        // si se quita el archivo (input vacío) → compactar
        if (!uploadedFile) {
          Vue.set(destination.files, index, null)
          Vue.set(this.formErrors.other_documents, index, '')

          return
        }

        // validaciones
        const errorMessages = []

        if (errorMessages.length) {
          Vue.set(this.formErrors.other_documents, index, errorMessages.join(' | '))
        } else {
          // Guardamos el archivo con un ID único para forzar re-render
          Vue.set(destination.files, index, {
            file: uploadedFile,
            id: Date.now()
          })
          Vue.set(this.formErrors.other_documents, index, '')
        }
      } else {
        // documentos normales
        Vue.set(this.formErrors, document.key, '')

        if (!uploadedFile) {
          Vue.set(destination, 'files', [])
          Vue.set(
            this.formErrors,
            document.key,
            this.$t('paymentMedias.errors.invalidFields')
          )
          return
        }

        if (!this.fileValidations.formats.includes(uploadedFile.type)) {
          errorMessages.push(this.$t('paymentMedias.profileRequests.formErrors.invalidType'))
        }
        if (this.fileValidations.maxSize < uploadedFile.size) {
          errorMessages.push(this.$t('paymentMedias.profileRequests.formErrors.tooBig'))
        }

        if (errorMessages.length) {
          Vue.set(this.formErrors, document.key, errorMessages.join(' | '))
        } else {
          Vue.set(destination, 'files', [uploadedFile])
        }
      }
    },

    createProfileRequest() {
      const vm = this
      let cont = 0
      const formData = new FormData()
      formData.append('profile_id', this.profile_id)
      formData.append('valid_from', this.valid_from)
      formData.append('valid_until', this.valid_until)
      formData.append('administrative_area_id', vm.$currentAccount.administrative_area_id)
      formData.append('rut', vm.$currentAccount.rut)
      formData.append('document_type', vm.$currentAccount.document_type || 1)

      if (this.documents_needed_file !== undefined) {
        // eslint-disable-next-line no-restricted-syntax
       
   
        for (const identifier in this.documents_needed_file) {
          if (this.documents_needed_file[identifier] !== undefined) {
            this.documents_needed_file[identifier].files.forEach((file, index) => {
              const key = this.documents_needed_file[identifier].key
              if (!file) return
              if (key === 'other_documents') {
                formData.append(`${key}[${cont}]`, file.file)
                cont += 1
              } else {
                formData.append(`${key}[${index}]`, file)
              }
            })
          }
        }
      }

      ProfileRequestService.create(formData).then(() => {
        this.sendNotificationSuccess()
        this.$emit('reloadProfileRequests')
        this.close()
      }, response => {
        if (response.status === 422) {
          this.sendNotificationFormErrors()
          this.formErrors = response.body.errors
          this.enableSendButton = true
        } else {
          this.sendNotificationFailure()
        }
      })
    },

    getDocumentError(document_needed) {
      return this.formErrors[document_needed] || ''
    },
    close() {
      this.$emit('close')
    },

    sendNotificationSuccess() {
      this.$notifications.send({
        id: 'profile-request-success',
        text: this.$t('paymentMedias.profileRequests.successMessage'),
        type: 'success',
        close: true
      })
    },
    sendNotificationFormErrors() {
      this.$notifications.send({
        id: 'profile-request-form-errors',
        text: this.$t('paymentMedias.profileRequests.formErrorsMessage'),
        type: 'error',
        close: true
      })
    },
    sendNotificationFailure() {
      this.$notifications.send({
        id: 'profile-request-failure',
        text: this.$t('paymentMedias.profileRequests.failureMessage'),
        type: 'error',
        close: true
      })
    },
    isMinor(doc_needed) {
      const birthday = this.$currentAccount.Birthday

      if (!birthday) {
        throw new Error("Formato de fecha inválido")
      }

      const birthDate = moment(birthday).toDate()

      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      const monthDiff = today.getMonth() - birthDate.getMonth()
      const dayDiff = today.getDate() - birthDate.getDate()

      // Si aún no cumplió años este año, restamos 1
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--
      }
      if (age < 18) {
        doc_needed = doc_needed.filter(
          doc => doc.key !== 'other_documents'
        )
      } else {
        doc_needed = doc_needed.filter(
          doc => doc.key !== 'parent_dni' && doc.key !== 'familyBook'
        )
      }

      return doc_needed
    },
    showRequiredField(document){
      if(document.key !== 'other_documents' &&
      this.formErrors[document.key] === this.$t('paymentMedias.errors.invalidFields')) {
        return true
      } else {
        return false
      }
    }

  }
}
